<template>
  <div ref="slideOutMenu" class="slide-out-menu" :class="{ 'is-open': isOpen }">
    <!-- Title and close button -->
    <div class="menu-title">
      <BaseTitle class="title centered">
        {{ title }}
      </BaseTitle>
      <BaseIcon
        icon="close"
        class="close-icon interactive"
        @click="isOpen = false"
      />
    </div>
    <slot name="fixed" />

    <!-- Menu content -->
    <div class="menu-content">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  isOpen: boolean;
  title: string;
}>();

// V-model for the 'close' icon
const emit = defineEmits(["update:isOpen"]);
const isOpen = useVModel(props, "isOpen", emit);

const slideOutMenu = ref<HTMLElement | null>(null);
onClickOutside(slideOutMenu, () => {
  isOpen.value = false;
});
</script>

<style lang="scss" scoped>
.slide-out-menu {
  position: fixed;
  overscroll-behavior: contain;
  right: calc(min(600px, 100%) * -1);
  width: 600px;
  max-width: 100%;
  height: 100%;
  background-color: $light-100;
  transition: all 0.3s ease-in-out;
  height: 100%;
  box-shadow: -4px 0px 12px 0px rgba($dark-100, 0);

  display: flex;
  flex-direction: column;
  overflow: hidden;

  z-index: 5;

  &.is-open {
    transform: translateX(-100%);
    box-shadow: -4px 0px 12px 0px rgba($dark-100, 0.1);
  }

  .menu-title {
    padding: 1rem;
    display: flex;
    align-items: center;

    .title {
      flex: 1;
    }
    .close-icon {
      margin-left: auto;
    }
  }

  .menu-content {
    flex: 1;
    overflow-y: auto;
  }
}
</style>
